import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Card,
  CardContent,
  CardHeader,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Button,
} from '@mui/material';
import {
  RestaurantMenu as RestaurantIcon,
  EventAvailable as ReservationIcon,
  Group as UsersIcon,
  Notifications as NotificationIcon,
} from '@mui/icons-material';

// Mock data
const recentReservations = [
  {
    id: 1,
    customerName: 'John Smith',
    restaurantName: 'Italian Delight',
    time: '2023-06-15T18:30:00',
    guests: 4,
  },
  {
    id: 2,
    customerName: 'Emily Johnson',
    restaurantName: 'Sushi Express',
    time: '2023-06-15T19:00:00',
    guests: 2,
  },
  {
    id: 3,
    customerName: 'Michael Brown',
    restaurantName: 'Steakhouse Grill',
    time: '2023-06-15T20:15:00',
    guests: 6,
  },
];

const notifications = [
  {
    id: 1,
    message: 'New restaurant signup request from "Thai Fusion"',
    time: '30 minutes ago',
  },
  {
    id: 2,
    message: 'User reported an issue with reservation #12456',
    time: '2 hours ago',
  },
  {
    id: 3,
    message: 'System maintenance scheduled for June 20, 2023',
    time: '1 day ago',
  },
];

const DashboardPage = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" component="h1">
          Dashboard
        </Typography>
        <Button variant="contained" color="primary">
          Generate Report
        </Button>
      </Box>

      {/* Summary Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <RestaurantIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
              <Typography variant="h4" component="div" fontWeight="bold">
                48
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Active Restaurants
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <ReservationIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
              <Typography variant="h4" component="div" fontWeight="bold">
                156
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Today's Reservations
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <UsersIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
              <Typography variant="h4" component="div" fontWeight="bold">
                2,541
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Registered Users
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <Card elevation={2}>
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <Avatar sx={{ bgcolor: '#FF5A5F', width: 48, height: 48, mx: 'auto', mb: 1 }}>
                <Typography variant="h5">$</Typography>
              </Avatar>
              <Typography variant="h4" component="div" fontWeight="bold">
                $12.5K
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Weekly Revenue
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Recent Activity and Notifications */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper elevation={2}>
            <CardHeader title="Recent Reservations" />
            <Divider />
            <List sx={{ pt: 0 }}>
              {recentReservations.map((reservation) => (
                <React.Fragment key={reservation.id}>
                  <ListItem alignItems="flex-start">
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: '#00A699' }}>
                        <ReservationIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography variant="subtitle1" fontWeight="medium">
                          {reservation.customerName} • {reservation.guests} guests
                        </Typography>
                      }
                      secondary={
                        <React.Fragment>
                          <Typography component="span" variant="body2" color="text.primary">
                            {reservation.restaurantName}
                          </Typography>
                          {` — ${new Date(reservation.time).toLocaleString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                          })}`}
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </React.Fragment>
              ))}
            </List>
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <Button color="primary">View All Reservations</Button>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper elevation={2}>
            <CardHeader title="Recent Notifications" />
            <Divider />
            <List sx={{ pt: 0 }}>
              {notifications.map((notification) => (
                <React.Fragment key={notification.id}>
                  <ListItem alignItems="flex-start">
                    <ListItemAvatar>
                      <Avatar sx={{ bgcolor: '#FF5A5F' }}>
                        <NotificationIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={notification.message}
                      secondary={notification.time}
                    />
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </React.Fragment>
              ))}
            </List>
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <Button color="primary">View All Notifications</Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DashboardPage; 